<template>
    <v-container fluid class="pa-0">
        <v-layout row>
            <v-layout column>
                <v-card>
                    <v-card-title>
                        <v-layout column>
                            <v-layout row class="mb-2">
                                <h2 class="display-1">Birthdays & Anniversaries</h2>
                            </v-layout>

                            <v-layout row>
                                <template>
                                    <v-flex>
                                        <v-select v-model="selectedMonths" :items="months" label="Months" chips multiple></v-select>
                                    </v-flex>
                                    <v-spacer></v-spacer>
                                    <v-flex xs12 sm3>
                                        <v-select
                                            :items="filterOptions"
                                            v-model="filters"
                                            attach
                                            chips
                                            label="Filter By"
                                            multiple
                                        ></v-select>
                                    </v-flex>
                                </template>
                                <v-spacer></v-spacer>
                                <v-btn @click="getReports" color="primary">Search</v-btn>
                                <v-btn @click="csvExport" color="primary" v-if="users.length > 0">
                                    Export
                                    <v-icon>arrow_downward</v-icon>
                                </v-btn>
                                <v-spacer></v-spacer>
                            </v-layout>
                        </v-layout>
                    </v-card-title>

                    <v-card-text>
                        <v-layout row justify-center align-center class="text-xs-center mb-4" v-if="users.length">
                            <v-flex> {{ totalItems }} {{ formatFilters() }} found</v-flex>
                        </v-layout>
                        <v-data-table
                            hide-actions
                            :loading="reportsPending"
                            :headers="roledHeaders"
                            :items="users"
                            :total-items="totalItems"
                            item-key="id"
                            class="elevation-1"
                        >
                            <template slot="items" slot-scope="{ item }">
                                <tr>
                                    <td>{{ item.first_name }}</td>
                                    <td>{{ item.last_name }}</td>
                                    <td :bgcolor="highlightDate(item.birthday, 'birthdays') ? '#FAFAFA' : ''">
                                        <span :class="highlightDate(item.birthday, 'birthdays') ? 'font-weight-bold' : ''">{{
                                            item.birthday | moment("MMMM D, YYYY")
                                        }}</span>
                                    </td>
                                    <td :bgcolor="highlightDate(item.start_date, 'anniversaries') ? '#FAFAFA' : ''">
                                        <span :class="highlightDate(item.start_date, 'anniversaries') ? 'font-weight-bold' : ''">{{
                                            item.start_date | moment("MMMM D, YYYY")
                                        }}</span>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                        <v-layout row justify-end align-center>
                            <v-spacer />
                            <v-flex shrink v-if="pagination.rowsPerPage > 0">
                                <v-pagination label="Page" v-model="pagination.page" :length="totalPages" />
                            </v-flex>
                            <v-spacer />
                            <v-flex shrink>
                                <v-select :items="pageOptions" v-model="pagination.rowsPerPage" label="Rows per Page" />
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-layout>
        </v-layout>
    </v-container>
</template>

<script>
import ApiField from "@/components/base/api-field.vue";
import { mapState, mapGetters } from "vuex";
import PunchRow from "@/components/calendar/punch.vue";
import { ExportToCsv } from "export-to-csv";
import _ from "lodash";

export default {
    components: {
        PunchRow,
        ApiField,
    },
    computed: {
        ...mapState("userAuth", ["user"]),
        rowsPerPage() {
            return this.pagination.rowsPerPage;
        },
        currentPage() {
            return this.pagination.page;
        },
        totalPages() {
            if (this.totalItems < 1) {
                return 1;
            }
            return Math.ceil(this.totalItems / this.pagination.rowsPerPage);
        },
        roledHeaders() {
            if (this.user.clientAdmin) {
                const trimmedHeaders = this.headers.filter((h) => h.text != "VSS Managers");
                return trimmedHeaders;
            }
            return this.headers;
        },
    },
    mounted() {
        this.getReports();
    },
    watch: {
        rowsPerPage() {
            this.page = 1;
            this.getReports();
        },
        currentPage() {
            this.getReports();
        },
    },
    data: function () {
        return {
            pageOptions: [
                { text: "5", value: 5 },
                { text: "10", value: 10 },
                { text: "25", value: 25 },
                { text: "50", value: 50 },
                { text: "All", value: -1 },
            ],
            reportsPending: false,
            users: [],
            totalItems: 0,
            selectedMonths: [],
            months: [
                { text: "January", value: 1 },
                { text: "February", value: 2 },
                { text: "March", value: 3 },
                { text: "April", value: 4 },
                { text: "May", value: 5 },
                { text: "June", value: 6 },
                { text: "July", value: 7 },
                { text: "August", value: 8 },
                { text: "September", value: 9 },
                { text: "October", value: 10 },
                { text: "November", value: 11 },
                { text: "December", value: 12 },
            ],
            filters: ["birthdays", "anniversaries"],
            filterOptions: [
                { text: "Birthday", value: "birthdays" },
                { text: "Anniversary Date", value: "anniversaries" },
            ],
            pagination: {
                rowsPerPage: 10,
                page: 1,
            },
            headers: [
                { text: "First Name", sortable: false, value: "user.first_name" },
                { text: "Last Name", sortable: false, value: "user.last_name" },
                { text: "Birthdate", sortable: false, value: "user.birthday" },
                { text: "Anniversary Date", sortable: false, value: "user.start_date" },
            ],
        };
    },

    methods: {
        getReports() {
            this.reportsPending = true;
            this.$store
                .dispatch("reports/getBirthdaysAnniversaries", {
                    selectedMonths: this.selectedMonths,
                    filters: this.filters,
                    limit: this.pagination.rowsPerPage,
                    offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
                })
                .then((res) => {
                    this.users = res.users;
                    this.totalItems = res.total;
                })
                .catch((err) => {
                    console.log(err);
                })
                .finally((res) => {
                    this.reportsPending = false;
                });
        },
        csvExport() {
            const options = {
                fieldSeparator: ",",
                quoteStrings: '"',
                decimalSeparator: ".",
                showLabels: true,
                showTitle: false,
                filename: `birthdays_and_anniversaries_${this.$moment().format("YYYY-MM-DD_HH-mm-ss")}`,
                useTextFile: false,
                useBom: true,
                useKeysAsHeaders: true,
            };

            const usersToExport = this.users.map((user) => {
                return _.pick(user, ["first_name", "last_name", "birthday", "start_date"]);
            });

            const csvExporter = new ExportToCsv(options);
            csvExporter.generateCsv(usersToExport);
        },
        ifSelectedMonth(date) {
            const month = this.$moment(date).month() + 1;
            return this.selectedMonths.includes(month);
        },
        formatFilters() {
            const filtersCaps = this.filters.map((filter) => {
                return filter.charAt(0).toUpperCase() + filter.slice(1);
            });

            return filtersCaps.join(" or ");
        },
        highlightDate(date, filter) {
            return this.ifSelectedMonth(date) && this.filters.includes(filter);
        },
    },
};
</script>

<style scoped></style>
